import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { publications } from '../data/publications';

const Publications: React.FC = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <div className="pt-20 md:pt-24">
      <section
        ref={ref}
        className="py-20 md:py-28 bg-white min-h-screen"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-penn-blue mb-6">
              Publications & Research Output
            </h1>
            <div className="w-24 h-1 bg-penn-red mx-auto mb-8"></div>
            <p className="text-lg md:text-xl text-neutral-dark max-w-3xl mx-auto leading-relaxed">
              Our lab's research has been published in leading neuroscience and medical
              journals. We are committed to open science and making our findings accessible
              to the broader research community.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6"
          >
            {publications.map((pub, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                className="bg-neutral-light rounded-lg p-6 md:p-8 shadow-md hover:shadow-lg transition-shadow border border-neutral-medium"
              >
                <h3 className="text-xl md:text-2xl font-bold text-penn-blue mb-3">
                  {pub.url ? (
                    <a
                      href={pub.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-penn-red transition-colors"
                    >
                      {pub.title}
                    </a>
                  ) : (
                    pub.title
                  )}
                </h3>
                <p className="text-penn-red font-semibold mb-2">
                  {pub.journal}
                </p>
                <p className="text-neutral-dark mb-2">
                  {pub.authors}
                </p>
                {pub.epub && (
                  <p className="text-sm text-neutral-dark/70 mb-2">
                    {pub.epub}
                  </p>
                )}
                {pub.doi && (
                  <p className="text-sm text-neutral-dark/70 mb-2">
                    DOI: {pub.doi}
                  </p>
                )}
                {pub.url && (
                  <a
                    href={pub.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-penn-red hover:text-penn-blue font-semibold transition-colors text-sm"
                  >
                    Read publication
                    <svg
                      className="w-4 h-4 ml-1"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Publications;


